import { instance2 } from "App/constants";

export const TYPE_REGISTRASI_RAWAT_JALAN = "Rawat Jalan";
export const TYPE_REGISTRASI_RAWAT_INAP = "Rawat Inap";
export const KODE_PPK_RUJUKAN = process.env.REACT_APP_KODE_PPK_RUJUKAN;
export const NAMA_PPK_RUJUKAN = process.env.REACT_APP_NAMA_PPK_RUJUKAN;

export const LIST_URL_REGISTRASI = {
  kunjungan_rawat_jalan: {
    perusahaan: "/company/listcompany_regrj",
    asuransi: "/insurance/listinsurance_regrj",
    poliklinik: "/policlinic/listpoliclinic_rj",
    dokter: "/doctor/listdoctor_regrj",
    schedule_dokter: "/doctor/listscheduledoctor_id_regrj",
    layanan: "/layanan/listlayanan_regirj",
    layanan_ruang: "/layanan/listlayanan_ruang_id_rj",
    jenis_layanan: "/jenis_layanan/listjenis_layanan_regrj",
    kelas_kunjungan: "/registration/kelaskunjungan/listkelaskunjungan_regrj",

    add_rawat_jalan_onsite:
      "/registration/registration/addregistration_onsiterawatjalan",
    add_rawat_jalan_booking:
      "/registration/registration/addregistration_onsiterawatjalan_booking",

    update_rawat_jalan_antrian:
      "/registration/registration/updateregistration_onsiterawatjalan_antrian",
    update_rawat_jalan_onsite:
      "/registration/registration/updateregistration_onsiterawatjalan",

    cancel_rawat_jalan: "/registration/registration/cancel_registration_regrj",
    delete_rawat_jalan:
      "/registration/registration/deleteregistration_onsiterawatjalan",
  },

  kunjungan_rawat_inap: {
    list: "/registration/registration/listregistration_onsiterinap",
    export: "/registration/registration/listregistration_onsiterinap_export",
    add_rawat_inap_onsite:
      "/registration/registration/addregistration_onsiterawatinap",
    update_rawat_inap_onsite:
      "/registration/registration/updateregistration_onsiterawatinap",
    cancel_rawat_inap: "/registration/registration/cancel_registration_rri",
    delete_rawat_inap:
      "/registration/registration/deleteregistration_onsiterawatinap",
    jenis_layanan: "/jenis_layanan/listjenis_layanan_regri",
    kelas_kunjungan: "/registration/kelaskunjungan/listkelaskunjungan_regri",
    perusahaan: "/company/listcompany_regri",
    kelas_kamar: "/bed/listkelaskamar_ri",
    asuransi: "/insurance/listinsurance_regri",
    dokter: "/doctor/listdoctor_regri",

    schedule: "/doctor/listscheduledoctor_id_regri",
    spesialis: "/spesialist/listspesialist_regri",
    bed: "/bed/listbed_regri",
    filter_internal: "/patient/listpatientsfilter_regri",
    filter_eksternal: "/patient/listpatientsfilter_external",
    count: "/registration/registration/countregistration_onsiterinap",
  },

  kunjungan_igd: {
    list: "/registration/registration/listregistration_onsiteigd",
    add: "/registration/registration/addregistration_onsiteigd",
    update: "/registration/registration/updateregistration_onsiteigd",
    delete: "/registration/registration/deleteregistration_onsiteigd",
    export: "/registration/registration/listregistration_onsiteigd_export",
    jenis_layanan: "/jenis_layanan/listjenis_layanan_regri",

    kelas_kunjungan: "/registration/kelaskunjungan/listkelaskunjungan_regri",
    perusahaan: "/company/listcompany_regigd",
    asuransi: "/insurance/listinsurance_regigd",
    dokter: "/doctor/listdoctor_regigd",
    schedule: "/doctor/listscheduledoctor_id_regri",
    bed: "/bed/listbed_regri",

    filter_internal: "/patient/listpatientsfilter_regrj",
    filter_eksternal: "/patient/listpatientsfilter_external",
  },

  masterKelasKunjungan: {
    getTarif: "/kelaskunjungan/listtarif",
  },

  member: {
    list_user_mobile: "/mobile_registrasi/list-user-mobile",
    list_member_by_user: "/mobile_registrasi/list-member-by-user",
    list_member_non_verif: "/mobile_registrasi/list-member-need-verif",
    alih_member: "/mobile_registrasi/update-member",
    update_status_member: "/mobile_registrasi/upate-status-member",
    count_user: "/mobile_registrasi/count-users",
    delete_member: "/mobile_registrasi/delete-member",
    member_ktp: "/mobile_registrasi/ktp-member-id",
    reset_pass: "/mobile_registrasi/reset-password-mobile",
    reset_email: "/mobile_registrasi/upate-email-mobile",
  },

  rawat_bersama:{
    list: "/registration/rawat-bersama/list-filter",
    create: "/registration/rawat-bersama/create",
    update: "/registration/rawat-bersama/update",
    delete: "/registration/rawat-bersama/delete",
    update_status : "/registration/rawat-bersama/update-dpjp"
  }
};

export const fetchIdInsuranceUmum = async () => {
  try {
    const response = await instance2.get("/insurance/listinsurance_type", {
      headers: {
        insurance_type_id: 1,
      },
    });
    return {
      state: true,
      data: response.data.body[0],
    };
  } catch (error) {
    return {
      state: false,
      data: {},
    };
  }
};

export const fetchIdInsuranceBpjs = async () => {
  try {
    const response = await instance2.get("/insurance/listinsurance_type", {
      headers: {
        insurance_type_id: 2,
      },
    });
    return {
      state: true,
      data: response.data.body[0],
    };
  } catch (error) {
    return {
      state: false,
      data: {},
    };
  }
};
